/* =============================================================================
 * Top Highlights (nsyao0g6)
 *
 * Product highlight pills. Pills are rendered server-side in Liquid from the
 * slot payload (entry.content.items → { title, detail }). This script is a
 * passive enhancer: it wires up the optional detail popup and fires analytics.
 * ============================================================================= */

;(() => {
  if (window.__sai_nsyao0g6_initialized__) return
  window.__sai_nsyao0g6_initialized__ = true

  const TAG = 'sai-nsyao0g6'
  const FEATURE_SLUG = 'top_highlights'

  function noopTrack() {}

  if (!customElements.get(TAG)) {
    class SaiTopHighlights extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return
        this._initialized = true
        requestAnimationFrame(() => this._init())
      }

      _init() {
        this._track = noopTrack
        const list = this.querySelector('.sai-nsyao0g6__list')
        if (!list) return

        const bind = window.__spectrumAi?.snippet?.bind
        if (bind) {
          const { track } = bind(this, () => {})
          this._track = track
        }

        const pills = list.querySelectorAll('.sai-nsyao0g6__pill')
        this._track(`${FEATURE_SLUG}:render`, { highlight_count: pills.length })

        this._wirePopups(list)
      }

      _wirePopups(list) {
        const detailPills = list.querySelectorAll('.sai-nsyao0g6__pill--has-detail')
        if (detailPills.length === 0) return

        let activePopup = null
        const closePopup = () => {
          if (activePopup) {
            activePopup.remove()
            activePopup = null
          }
        }

        for (const pill of detailPills) {
          const titleText = (
            pill.querySelector('.sai-nsyao0g6__pill-text') || pill
          ).textContent.trim()
          pill.addEventListener('click', (e) => {
            e.stopPropagation()
            const detail = pill.getAttribute('data-detail') || ''

            if (activePopup && activePopup._forPill === pill) {
              closePopup()
              return
            }

            closePopup()
            const popup = document.createElement('div')
            popup.className = 'sai-nsyao0g6__popup'
            popup.textContent = detail
            popup._forPill = pill
            pill.appendChild(popup)
            activePopup = popup

            this._track(`${FEATURE_SLUG}:detail_expand`, { highlight_title: titleText })
          })
        }

        document.addEventListener('click', closePopup)
      }
    }

    customElements.define(TAG, SaiTopHighlights)
  }
})()
